<script>
import PaymentEdit from "~/src/components/modals/PaymentEdit2022.vue";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  components: { PaymentEdit },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    label: String,
  },

  data: () => ({
    isShowEdit: false,
    canUpdate: false,
    confirmDelete: false,
    deleting: false,
  }),

  async mounted() {
    this.canUpdate = await this.hasRole("KONTRAKT_24_25", "UPDATE");
  },

  methods: {
    ...mapActions("admin-contract2022", ["DELETE_PAYMENT"]),
    onShowEdit() {
      this.isShowEdit = true;
    },

    onRefresh() {
      this.$emit("refresh");
    },
    onShowDelete() {
      this.confirmDelete = true;
    },
    async onConfirmDelete() {
      if (!this.itemData?.id) return;
      this.deleting = true;
      const ok = await this.DELETE_PAYMENT(this.itemData.id);
      this.deleting = false;
      this.confirmDelete = false;
      if (ok) this.onRefresh();
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },
  },
};
</script>

<template>
  <div>
    <payment-edit
      v-if="isShowEdit"
      @close="isShowEdit = false"
      @refresh="onRefresh"
      :data="itemData"
      :contractId="$route.params.id"
    />

    <div class="_wrap">
      <div class="-text" v-text="label" />
      <br />

      <v-icon
          v-if="canUpdate"
          @click="onShowEdit"
          small
          class="ml-1 cursor-pointer text-gray-600 hover:text-gray-800 transition"
      >
        mdi-pencil
      </v-icon>
      <v-icon
          v-if="canUpdate && itemData && itemData.id"
          @click="onShowDelete"
          small
          color="red darken-2"
          class="ml-1 cursor-pointer transition"
      >
        mdi-trash-can-outline
      </v-icon>
    </div>

    <v-dialog v-model="confirmDelete" max-width="440" persistent>
      <v-card>
        <v-card-title class="headline">{{ $t("To'lovni o'chirish?") }}</v-card-title>
        <v-card-text>
          <div>{{ $t("Bu amalni qaytarib bo'lmaydi. To'lov o'chirilgandan keyin kontrakt summalari avtomatik qayta hisoblanadi.") }}</div>
          <div class="mt-3 text-body-2" style="color:#475569">{{ label }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="deleting" @click="confirmDelete = false">{{ $t("Bekor qilish") }}</v-btn>
          <v-btn color="red darken-1" dark :loading="deleting" :disabled="deleting" @click="onConfirmDelete">
            {{ $t("O'chirish") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
._wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.-text {
  font-weight: 500;
}
</style>
